module.exports = __webpack_public_path__ + "img/K9.738cc13b.jpg";